// extracted by mini-css-extract-plugin
export default {"title":"StatCardPanel_title__no+yB","statCardPanel":"StatCardPanel_statCardPanel__Ju6k-"};